import React, { useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { Store } from "react-notifications-component";
import SignupAPIvalidation from "./SignupAPIvalidation";
import UserNumberVerify from "./UserNumberVerify";
import "./Login.css";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function Signup() {
  const { RendomTokenfetch } = useAuth();
  // const navigate = useNavigate();
  const notification = {
    // message: "teodosii@react-notifications-component",
    insert: "top",
    container: "bottom-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 2000,
      showIcon: true,
      onScreen: true,
    },
  };

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const [NumbervarifyShow, setNumbervarifyShow] = useState(false);

  const [Data, setData] = useState({
    fname: "",
    lname: "",
    email: "",
    password: "",
    number: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const [error, setError] = useState({});

  const handleChange = (e) => {
    setData({ ...Data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let fdata = new FormData();
    fdata.append("firstname", Data.fname);
    fdata.append("lastname", Data.lname);
    fdata.append("email", Data.email);
    fdata.append("number", Data.number);
    fdata.append("password", Data.password);

    axios
      .post(`${WebsiteAPIurl}userregister`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (
          Data.fname &&
          Data.lname &&
          Data.email &&
          Data.number &&
          Data.password
        ) {
          if (response.data.Status === "0") {
            // alert(response.data.msg);
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "danger",
            });
            if (response.data.form_validation) {
              setError(SignupAPIvalidation(response.data.form_validation));
            }
          }
          if (response.data.Status === "1") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "success",
            });
            // window.localStorage.setItem("varifyuser", "0");
            // window.localStorage.setItem("varifyuserStatus", "0");
            // navigate("/login");
            setNumbervarifyShow("true");
          }
        } else {
          // console.log(response.data);
          setError(SignupAPIvalidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  return (
    <>
      <Helmet>
        <title>{"Register"}</title>
        <meta name="robots" content="index, follow"></meta>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <section className="login-section section_padding_top bgc-home20">
        <div className="login-form default-form login_page_form">
          <div className="form-inner">
            {NumbervarifyShow === false ? (
              <>
                <h3>Register Here</h3>

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>
                      First Name<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="fname"
                      value={Data.fname}
                      onChange={handleChange}
                    />
                    {error.firstname && (
                      <span className="text-danger">* {error.firstname}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Last Name<span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="lname"
                      value={Data.lname}
                      onChange={handleChange}
                    />
                    {error.lastname && (
                      <span className="text-danger">* {error.lastname}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Email ID<span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      value={Data.email}
                      onChange={handleChange}
                    />
                    {error.email && (
                      <span className="text-danger">* {error.email}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>
                      Mobile Number<span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="number"
                      value={Data.number}
                      onChange={handleChange}
                      onKeyPress={handleKeyPress}
                      maxLength={10}
                      inputMode="numeric"
                    />
                    {error.number && (
                      <span className="text-danger">* {error.number}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Password<span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      id="password-field"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={Data.password}
                      onChange={handleChange}
                    />
                    <span
                      onClick={togglePasswordVisibility}
                      className="paaswordshowhide"
                    >
                      {showPassword ? (
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      ) : (
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                      )}
                    </span>
                    {error.password && (
                      <span className="text-danger">* {error.password}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <button
                      className="theme-btn btn-style-one"
                      type="submit"
                      name="submit"
                    >
                      Sign In
                    </button>
                  </div>
                </form>

                <div className="bottom-box text-center d-block">
                  <div className="text">
                    Allready have an account?{" "}
                    <NavLink to="/login">Login</NavLink>
                  </div>
                </div>
              </>
            ) : (
              <UserNumberVerify
                RendomTokenfetch={RendomTokenfetch}
                userNumber={Data.number}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
}
